<template>
	<popup
			@updateClosePopup="onClose"
			height-head="40px"
			title="Customers"
			isHideBottom
			is-all-height
	>
		<div class="formDialog customerForm" :class="{ 'onlyViewWrap': getPermissionAction }">
			<div class="formDialogHeader" :class="{ 'onlyView': getPermissionAction }">
				<div class="formDialogHeader_card left">
					<logo-block
							:logo="logo"
							title="Customer logo"
							@updateFile="onFile"
					></logo-block>
				</div>
				<div class="formDialogHeader_card service">
					<field
							:classError="$v.name.$error"
							width="220px"
							margin="0"
							label="Customer name"
							placeholder="Enter unique name"
							@updateInput="onInput($event, 'name')"
							:setInputValue="name"
							is-required
					></field>
					<field
							:classError="$v.email.$error"
							width="220px"
							margin="0"
							label="Email"
							placeholder="Enter email"
							@updateInput="onInput($event, 'email')"
							:setInputValue="email"
							is-required
							isClip
					></field>
					<field
							:classError="$v.phone.$error"
							width="160px"
							margin="0"
							label="Phone"
							placeholder="Enter phone"
							@updateInput="onInput($event, 'phone')"
							:setInputValue="phone"
							is-required
							is-phone-mask
					></field>
					<field
							width="130px"
							margin="0"
							type="text"
							label="Created date"
							placeholder="Enter date"
							:dateValue="created_at"
							is-date
							is-readonly
					></field>
					<field
							width="130px"
							margin="0"
							type="number"
							label="Balance"
							placeholder="0"
							:setInputValue="balance"
							:isColorInput="balance >= 0"
							is-readonly
					></field>

					<div class="checkboxWrapper">
						<v-switch
								class="switchFrozen"
								v-model="daptor"
								label="Debtor"
								color="success"
								hide-details
						></v-switch>
						<v-switch
								v-if="!isCustomers"
								class="switchFrozen"
								v-model="frozen"
								label="Frozen"
								color="success"
								hide-details
						></v-switch>
						<v-switch
								v-if="!isCustomers"
								class="switchFrozen"
								v-model="notOur"
								label="Not our"
								color="success"
								hide-details
						></v-switch>
						<v-switch
								v-if="!isCustomers"
								class="switchFrozen"
								v-model="spot_rate"
								label="Spot rate"
								color="success"
								hide-details
						></v-switch>
					</div>
				</div>
			</div>

			<div class="tabBlock">
				<div>

					<tab-block
							:tab="tab"
							:tab-list="getTabList"
							@updateTab="onTab"
					></tab-block>

					<v-tabs-items v-if="customersList" v-model="tab" class="tabs-items">
						<v-tab-item>
							<first-tab
									:valid="$v"
									:subcompanies="subcompanies"
									:select_companies_list="getSelectCompaniesList"
									:subcompanies_type="subcompanies_type"
									:subcompanies_name="subcompanies_name"
									:subcompanies_status="subcompanies_status"
									:getPermissionAction="getPermissionAction"
									:isCustomers="isCustomers"
									:siDisabledFindUs="getDifferenceInDays"
									@updateData="onOneTabData"
									@updateSubcompaniesType="onSubcompaniesType"
									@updateSubcompaniesList="onSubcompaniesList"
									@updateSubcompaniesDelete="onSubcompaniesDelete"
							></first-tab>
						</v-tab-item>
						<v-tab-item v-if="!isCustomers">
							<second-tab
									:services="services"
									:requisites="requisites"
									:drivers="drivers"
									:percent="percent"
									:billing_rate_driver="billing_rate_driver"
									:safety_rate_driver="safety_rate_driver"
									:information="information"
									:valid="$v"
									:billing_history="billing_history"
									:dispatcher_history="dispatcher_history"
									:safety_history="safety_history"
									:factoring="factoring"
									:factoring_id="factoring_id"
									:dnu="dnu"
									:getPermissionAction="getPermissionAction"
									@updateServiceKey="onServiceKey"
									@updateDispatch="onDispatch"
									@updateSafety="onSafety"
									@updateBilling="onBilling"
									@updatePercent="onRate($event, 'percent')"
									@updateSafetyRate="onRate"
									@updateBillingRate="onRate($event, 'billing_rate_driver')"
									@updateEditServices="onEditServices"
									@updateDnuList="onDnuList"
									@updateItemEld="onItemEld"
							></second-tab>
						</v-tab-item>
						<v-tab-item>
							<third-tab
									:valid="$v"
									:getPermissionAction="getPermissionAction"
									@updateData="onThreeTabData"
							></third-tab>
						</v-tab-item>
						<v-tab-item>
							<fourth-tab
									:getPermissionAction="getPermissionAction"
									@updateData="onFourthTabData"
									@updatePreviewAction="onPreviewAction"
							></fourth-tab>
						</v-tab-item>
						<v-tab-item>
							<fifth-tab
									:getPermissionAction="getPermissionAction"
									:users="users"
									:usersGroup="usersGroup"
									:valid="$v"
									@updateData="onFifthTabData"
							></fifth-tab>
						</v-tab-item>
						<v-tab-item>
							<sixth-tab></sixth-tab>
						</v-tab-item>
						<v-tab-item>
							<payment-transaction
									:id="id"
							/>
						</v-tab-item>
					</v-tabs-items>
				</div>
			</div>
			<button-groups
					:preloader="preloader"
					:isSave="!getPermissionAction"
					@updateBtnClose="onClose"
					@updateSave="onSave"
					isCancelHide
			></button-groups>
			<preview-doc v-if="link" @clear-link="clearLink" :link-doc="link" />
		</div>
	</popup>

</template>

<script>
import { mapActions, mapGetters } from "vuex";
// components
import FirstTab from "@/components/Maintenance/Customer/CustomerForm/FirstTab/FirstTab";
import PreviewDoc from "@/modules/invoices/preview";
import ButtonGroups from "@/shared/ButtonGroups/ButtonGroups";
import LogoBlock from "@/shared/LogoBlock/LogoBlock";
// validate
import { validationMixin } from "vuelidate";
import { email, required, sameAs, url } from "vuelidate/lib/validators";
import minValue from "vuelidate/lib/validators/minValue";
// helper
import getDefaultDate from "@/helper/getDefaultDate";
import { PERMISSIONS } from "@/constants/constants";
import moment from "moment/moment";
import Popup from "@/shared/Popup/Popup.vue";
import TabBlock from "@/shared/TabBlock/TabBlock.vue";
import PaymentTransaction from "@/components/Maintenance/Customer/CustomerForm/PaymentTransaction/PaymentTransaction.vue";
// async components
const SecondTab = () =>
	import("@/components/Maintenance/Customer/CustomerForm/SecondTab/SecondTab");
const ThirdTab = () =>
	import("@/components/Maintenance/Customer/CustomerForm/ThirdTab/ThirdTab");
const FourthTab = () =>
	import("@/components/Maintenance/Customer/CustomerForm/FourthTab/FourthTab");
const FifthTab = () =>
	import("@/components/Maintenance/Customer/CustomerForm/FifthTab/FifthTab");
const SixthTab = () =>
	import("@/components/Maintenance/Customer/CustomerForm/SixthTab/SixthTab");
const VALID_PERIOD_FIND_US = 14;

export default {
	name: "CustomerForm",
	mixins: [ validationMixin ],
	components: {
		PaymentTransaction,
		TabBlock,
		Popup,
		FirstTab,
		SecondTab,
		ThirdTab,
		FourthTab,
		FifthTab,
		SixthTab,
		PreviewDoc,
		ButtonGroups,
		LogoBlock,
	},
	props: {
		typeForm: String,
		item: Object,
		id: Number,
		isPage: Boolean,
	},
	computed: {
		...mapGetters([
			"customersList",
			"isCustomers",
			"isCustomers",
			'permissions'
		]),
		getDifferenceInDays() {
			const date = moment(this.created_at);
			const currentDate = moment();
			const differenceInDays = currentDate.diff(date, 'days');
			return differenceInDays >= VALID_PERIOD_FIND_US;
		},
		getPermissionAction() {
			if ((this.permissions[PERMISSIONS.CREATE] && !this.id) || this.permissions[PERMISSIONS.EDIT])
				return false;
			return this.permissions[PERMISSIONS.VIEW];
		},
		getTabList() {
			const {
				name,
				phone,
				email,
				dnu,
				dispatchersNik,
				exceptionList,
				billing_rate_driver,
				safety_rate_driver,
				percent,
				accounts,
				users,
				factoring_name,
				factoring_url,
			} = this.$v;

			const values = [
				{
					text: "General info",
					error: name.$error || phone.$error || email.$error,
				},
				{
					text: "Services",
					error:
							dispatchersNik.$error ||
							dnu.$error ||
							exceptionList.$error ||
							(billing_rate_driver && billing_rate_driver.$error) ||
							(safety_rate_driver && safety_rate_driver.$error) ||
							(percent && percent.$error) ||
							factoring_name.$error ||
							factoring_url.$error,
				},
				{
					text: "Accounts",
					error: accounts.$error,
				},
				{
					text: "Customer files",
					error: false,
				},
				{
					text: "Users",
					error: users.$error,
				},
			];

			if (this.isCustomers) {
				values.splice(1, 1);
			}

			if (this.typeForm !== "create" && !this.isCustomers) {
				values.push({
					text: "Logs",
					error: false,
				});
			}

			values.push({
				text: "Payment transaction",
				error: false,
			});

			return values;
		},
		getSelectCompaniesList() {
			return this.select_companies_list.map((item) => {
				item.disabled = this.subcompanies.some((body) => body.id === item.id);

				return item;
			});
		},
	},
	data: () => ({
		isTab: true,
		link: null,
		tab: 0,
		name: "",
		email: "",
		phone: "",
		assigned_date: getDefaultDate(),
		created_at: getDefaultDate(),
		balance: 0,
		frozen: false,
		daptor: false,
		notOur: false,
		spot_rate: true,
		division_id: "",
		dot: "",
		federal: "",
		mailing_address: "",
		mc: "",
		pdf_address: "",
		phisical_address: "",
		dnu: [],
		drivers: [],
		dispatchersNik: [],
		accounts: [],
		billing: 1,
		billing_email: "",
		billing_phone: "",
		factoring: false,
		factoring_address: "",
		factoring_manager: "",
		factoring_name: null,
		factoring_phone: "",
		factoring_id: null,
		factoring_account: "",
		factoring_url: "",
		factoring_login: "",
		factoring_password: "",
		logo: null,
		file: [],
		start_week: null,
		trailer_rate: [],
		percent_type: 1,
		safety_rate_driver: null,
		information: '',
		billing_rate_driver: null,
		percent: null,
		creator: {},
		services: {
			dispatch: {
				status: false,
				date: getDefaultDate(),
				services_id: 1,
				name: "Dispatch",
				id: null,
				manager_id: null,
				manager: null,
			},
			safety: {
				status: false,
				date: getDefaultDate(),
				services_id: 2,
				name: "Safety",
				id: null,
				manager_id: null,
				manager: null,
			},
			billing: {
				status: false,
				date: getDefaultDate(),
				services_id: 2,
				name: "Safety",
				id: null,
				manager_id: null,
				manager: null,
			},
		},
		users: [],
		requisites: [],
		exceptionList: [],
		billing_history: [],
		dispatcher_history: [],
		safety_history: [],
		trucks: [],
		usersGroup: [],
		subcompanies: [],
		select_companies_list: [],
		subcompanies_type: false,
		subcompanies_name: null,
		subcompanies_status: false,
		preloader: false,
		zelle_id: false,
		find_us_id: null,
		payment_names: [],
		isPaymentTransactionTabOpened: false,

	}),
	validations() {
		const { dispatch, billing, safety } = this.services;
		return {
			name: { required },
			phone: { required },
			zelle_id: { required },
			find_us_id: this.getDifferenceInDays ? {} : { required },
			email: { required, email },
			billing_email: { email },
			dispatchersNik: {
				$each: {
					id: dispatch.status ? { required } : {},
					name: dispatch.status ? { required } : {},
				},
			},
			accounts: {
				$each: {
					login: { required },
					name: { required },
					pass: { required },
					url: { required, url },
				},
			},
			exceptionList: {
				$each: {
					amount: dispatch.status
						? { required, minValueValue: minValue(0.1) }
						: {},
					type: dispatch.status ? { required } : {},
				},
			},

			users: {
				$each: {
					name: { required },
					email: { required, email },
					pass: { required },
					confirmPass: {
						required,
						sameAsPassword: sameAs("pass"),
					},
				},
			},
			dnu: {
				$each: {
					broker_id: dispatch.status ? { required } : {},
				},
			},
			subcompanies: {
				$each: {
					id: this.subcompanies_type ? { required } : {},
				},
			},
			percent: dispatch.status
				? { required, minValueValue: minValue(0.1) }
				: {},
			billing_rate_driver: billing.status
				? { required, minValueValue: minValue(0.1) }
				: {},
			safety_rate_driver: safety.status
				? { required, minValueValue: minValue(0.1) }
				: {},
			factoring_name: this.factoring && billing.status ? { required } : {},
			factoring_url: this.factoring && billing.status ? { url } : {},
		};
	},
	methods: {
		...mapActions([
			"setAlert",
			"getCustomerDetails",
			"onClearCustomerList",
			"onCreateCustomer",
			"onDeleteException",
			"getDeleteException",
			"onDeleteFiles",
			"getDeleteFiles",
		]),
		/**
		 * Changes active tab.
		 *
		 * @param {Number} value Tab index.
		 * @returns {void}
		 */
		onTab(value) {
			this.tab = value;

			const paymentTransactionTabIndex = this.getTabList.length - 1;

			if (value === paymentTransactionTabIndex) {
				this.isPaymentTransactionTabOpened = true;
			}
		},
		onItemEld({ item, idx }) {
			this.drivers.splice(idx, 1, item);
		},
		onDnuList(value) {
			this.dnu = value.map((item) => {
				item.broker_id = item.id;
				return item;
			});
		},
		onPreviewAction(value) {
			this.link = value;
		},
		clearLink() {
			this.link = null;
		},
		onInput({ value }, key) {
			console.log('%c [  value  ] ', 'color:#bada55', typeof value, value );
			console.log('%c [  key  ] ', 'color:#bada55', typeof key, key );
			this[key] = value;
			this.$v[key].$touch();
		},
		onFile(logo) {
			this.logo = logo;
		},
		onFileRemove() {
			this.logo = null;
		},

		/**
		 * Closes customer form.
		 *
		 * @returns {void}
		 */
		onClose() {
			this.$emit("updateClose", this.isPaymentTransactionTabOpened);
			this.onClearCustomerList();
		},

		onServiceKey({ status, date, serviceKey }) {
			this.services[serviceKey].status = status;
			this.services[serviceKey].date = date;
		},
		onDispatch({ creator, exceptionList, dispatchersNik }) {
			this.services.dispatch.manager_id = creator?.id;
			this.services.dispatch.manager = creator?.value;
			this.exceptionList = exceptionList;
			this.dispatchersNik = dispatchersNik;
		},
		onSafety({ creator, drivers }) {
			this.services.safety.manager_id = creator?.id;
			this.services.safety.manager = creator?.value;
			this.drivers = drivers;
		},
		onBilling({
			          creator,
			          factoringList,
			          requisitesList,
			          billing_email,
			          billing_phone,
			          factoring,
			          start_week,
		          }) {
			this.services.billing.manager_id = creator?.id;
			this.services.billing.manager = creator?.value;
			this.requisites = requisitesList;
			this.billing_phone = billing_phone;
			this.billing_email = billing_email;
			this.factoring = factoring;
			this.start_week = start_week?.id ?? start_week;

			Object.keys(factoringList || {}).forEach((item) => {
				this[item] = factoringList[item];
			});
		},
		onRate({ value, key }, localKey) {
			this[localKey || key] = value;
		},
		onOneTabData(data) {
			const {
				dot,
				federal,
				mc,
				pdf_address,
				phisical_address,
				mailing_address,
				zelle_id,
				find_us_id,
				payment_names,
			} = data;
			this.dot = dot;
			this.federal = federal;
			this.mc = mc;
			this.pdf_address = pdf_address;
			this.phisical_address = phisical_address;
			this.mailing_address = mailing_address;
			this.zelle_id = zelle_id;
			this.find_us_id = find_us_id;
			this.payment_names = payment_names;
		},
		onThreeTabData({ accountsList }) {
			this.accounts = accountsList;
		},
		onFourthTabData(files) {
			this.file = files;
		},
		onFifthTabData({ usersList }) {
			this.users = usersList.map((item) => ({ ...item }));
		},
		getModifiedList(array = []) {
			return array.map((item) => {
				const { date_from, date_to, trailer_rate, driver } = item;
				if (date_from || date_to) {
					item.date_from = date_from.slice(0, 10);
					item.date_to = date_to.slice(0, 10);
				}

				if (trailer_rate || driver) {
					item.isGroup = false;
				}

				return { ...item };
			});
		},
		onEditServices({ value, key }) {
			this[key] = this[key].map((item) => {
				if (item.id === value.id) {
					return value;
				}
				return item;
			});
		},
		async onSave() {
			this.$v.$touch();
			if (!this.$v.$error) {
				const {
					frozen,
					daptor,
					notOur,
					spot_rate,
					name,
					email,
					phone,
					assigned_date,
					dot,
					federal,
					mc,
					pdf_address,
					phisical_address,
					mailing_address,
					start_week,
					dnu,
					accounts,
					file,
					logo,
					services,
					drivers,
					billing_email,
					billing_phone,
					factoring_address,
					factoring_id,
					factoring_login,
					factoring_manager,
					factoring_name,
					factoring_password,
					factoring_url,
					factoring_account,
					factoring_phone,
					factoring,
					users,
					requisites,
					trailer_rate,
					dispatchersNik,
					exceptionList: exception,
					safety_rate_driver,
					information,
					billing_rate_driver,
					percent,
					billing_history,
					dispatcher_history,
					safety_history,
					subcompanies_type,
					zelle_id,
					find_us_id,
					payment_names,
					subcompanies: subcompaniesList,
				} = this.$data;

				const subcompanies = subcompaniesList.filter(({ id }) => {
					if (id) return { id };
				});

				users &&
				users.forEach((item) => {
					const { type } = item;
					item.type = type?.id ?? type;
				});

				const exceptionList = exception.map((item) => {
					const { type, rate, amount, truck_id } = item;
					item.rate = rate?.id ?? rate;
					item.type = type?.trailer_type_id ?? type;
					item.amount = amount;
					item.truck_id = truck_id?.id || null;
					item.status = 1;
					return item;
				});

				drivers &&
				drivers.forEach((item) => {
					item.status = item.status ? 1 : 0;
				});

				dnu.forEach((item) => {
					if (item.status) {
						item.id = null;
						delete item.status;
					}
				});

				const preparedPaymentNames = payment_names
					.map((item) => {
						if (typeof item === "string") {
							return item.trim();
						}

						return item?.name?.trim() || "";
					})
					.filter(Boolean);

				const values = {
					frozen,
					daptor,
					zelle_id,
					find_us_id,
					notOur,
					spot_rate,
					name,
					email,
					phone,
					assigned_date,
					dot,
					federal,
					mc,
					pdf_address,
					phisical_address,
					mailing_address,
					start_week,
					dnu,
					accounts,
					file,
					logo,
					services,
					drivers,
					billing_email,
					billing_phone,
					factoring_address,
					factoring_id,
					factoring_login,
					factoring_manager,
					factoring_name,
					factoring_password,
					factoring_url,
					factoring_account,
					factoring_phone,
					factoring,
					users,
					requisites,
					dispatchersNik,
					trailer_rate,
					exceptionList,
					safety_rate_driver: +safety_rate_driver,
					information,
					billing_rate_driver,
					percent,
					billing_history,
					dispatcher_history,
					safety_history,
					payment_names: preparedPaymentNames,
					subcompanies_type: Number(subcompanies_type),
					subcompanies,
				};

				const newRequest = { type: "new", isPage: this.isPage, values };
				const updateRequest = {
					type: `update/${ this.id }`,
					typeForm: this.typeForm,
					values,
					isPage: this.isPage,
				};

				const request = this.typeForm === "create" ? newRequest : updateRequest;

				this.preloader = true;
				const response = await this.onCreateCustomer(request);
				if (!response.error) {
					if (this.isPage) this.onClose();
					await this.onDeleteException();
					await this.onDeleteFiles();
					this.getDeleteException({ isDelete: true });
					this.getDeleteFiles({ isDelete: true });

					await this.setAlert({ type: "success", message: "Saving Successfully" });
					this.$emit("updateSave");
				} else {
					await this.setAlert({ type: "error", message: "The users email has already been taken." });
					console.error(response.error);
				}
				this.preloader = false;
			} else {
				await this.setAlert({ type: "error", message: "Saving error" });
			}
		},
		onSubcompaniesType(value) {
			this.subcompanies_type = value;
		},
		onSubcompaniesList({ item, idx }) {
			if (idx !== undefined) {
				this.subcompanies.splice(idx, 1, item);
			} else {
				this.subcompanies.push(item);
			}
		},
		onSubcompaniesDelete(idx) {
			this.subcompanies.splice(idx, 1);
		},
		onEditCustomer() {
			const {
				customers,
				dispatcherNik,
				dnu,
				file,
				service,
				trailer_rate,
				drivers,
				users,
				requisites,
				exceptionList,
				billing_history,
				dispatcher_history,
				safety_history,
				trucks,
				accounts,
				usersGroup,
				subcompanies,
				select_companies_list,
				payment_names,
			} = this.customersList;

			const {
				balance,
				email,
				phone,
				frozen,
				daptor,
				notOur,
				spot_rate,
				name,
				logo,
				assigned_date,
				billing_email,
				billing_phone,
				factoring_name,
				factoring_address,
				factoring_manager,
				factoring_phone,
				factoring_id,
				factoring_account,
				factoring_url,
				factoring_password,
				factoring_login,
				factoring,
				start_week,
				safety_rate_driver,
				information,
				billing_rate_driver,
				percent,
				created_at,
				subcompanies_name,
				subcompanies_status,
				subcompanies_type,
			} = customers;

			service.forEach((item) => {
				this.$set(this.services, item.name.toLowerCase(), { ...item });
			});

			const isFactoring = this.services.billing.status ? !!+factoring : false;

			const usersList =
					users &&
					users.map((item) => {
						const { pass, email = "" } = item;
						item.confirmPass = pass;
						item.email = email.toLocaleLowerCase();
						return item;
					});

			this.balance = balance ?? 0;
			this.name = name;
			this.email = email;
			this.phone = phone;
			this.frozen = !!frozen;
			this.daptor = !!daptor;
			this.notOur = !!notOur;
			this.spot_rate = !spot_rate;
			this.assigned_date = assigned_date || getDefaultDate();
			this.logo = logo;
			this.dispatchersNik = dispatcherNik;
			this.dnu = dnu;
			this.file = file;
			this.users = usersList;
			this.trailer_rate = trailer_rate;
			this.drivers = drivers;
			this.billing_phone = billing_phone;
			this.billing_email = billing_email;
			this.factoring_name = factoring_name;
			this.factoring_address = factoring_address;
			this.factoring_manager = factoring_manager;
			this.factoring_phone = factoring_phone;
			this.factoring_id = factoring_id;
			this.factoring_account = factoring_account;
			this.factoring_url = factoring_url;
			this.factoring_password = factoring_password;
			this.factoring_login = factoring_login;
			this.factoring = isFactoring;
			this.start_week = start_week;
			this.requisites = requisites;
			this.exceptionList = exceptionList || [];
			this.safety_rate_driver = safety_rate_driver;
			this.information = information || '';
			this.billing_rate_driver = billing_rate_driver;
			this.percent = percent;
			this.trucks = trucks;
			this.created_at =
					(created_at && created_at.slice(0, 10)) || getDefaultDate();
			this.accounts = accounts;
			this.billing_history = this.getModifiedList(billing_history);
			this.dispatcher_history = this.getModifiedList(dispatcher_history);
			this.safety_history = this.getModifiedList(safety_history);
			this.usersGroup = usersGroup;
			this.select_companies_list = select_companies_list;
			this.subcompanies_type = !!subcompanies_type;
			this.subcompanies_name = subcompanies_name;
			this.subcompanies_status = !!subcompanies_status;
			this.subcompanies = subcompanies_type
				? subcompanies.map((item) => {
					item.id = item.sub_id;
					return item;
				})
				: [ { sub_id: null } ];

			this.payment_names = Array.isArray(payment_names)
				? payment_names.map((item) => item?.name || "")
				: [];
		},
	},
	async mounted() {
		if (this.typeForm === "create") {
			await this.getCustomerDetails("new");
		} else {
			await this.getCustomerDetails(this.id);
		}

		this.onEditCustomer();
		this.isTab = false;
		this.getDeleteException({ isDelete: true });
	},
	destroyed() {
		this.onClearCustomerList();
	},
};
</script>

<style scoped lang="scss">
//@import "customerForm";
@import "@/assets/style/components/formDialog.scss";

</style>

<!--<style lang="scss">-->
<!--.safety + .salary {-->
<!--	margin-top: 20px;-->
<!--}-->

<!--</style>-->
